export default __webpack_public_path__ + "static/media/InfoIcon.e42bce84.svg";